import React, { useState, useEffect } from "react";
import Header from "../../Header";
declare const I18n;

import "./learner_submissions.css";

const LearnerSubmissions = ({ course, learner, lessons }) => {
  const [expandedLessonIds, setExpandedLessonIds] = useState([]);

  useEffect(() => {
    if (lessons.length > 0) {
      setExpandedLessonIds(lessons.map((lesson) => lesson.id));
    }
  }, [lessons]);

  const getFileNameFromURL = (url) => {
    try {
      const segments = url.split("/");
      return decodeURIComponent(segments[segments.length - 1]);
    } catch {
      return "View File";
    }
  };

  const isImageFile = (url) => {
    return /\.(jpg|jpeg|png|gif|svg)$/i.test(url);
  };

  const toggleLesson = (lessonId) => {
    setExpandedLessonIds((prev) =>
      prev.includes(lessonId)
        ? prev.filter((id) => id !== lessonId)
        : [...prev, lessonId]
    );
  };

  
  const getLessonStats = (lesson) => {
    const totalQuestions = lesson.questions.length;
    const quizQuestions = lesson.questions.filter((q) =>
      q.hasOwnProperty("attempts")
    );
    const answeredQuestions = quizQuestions.filter(
      (q) => q.is_completed
    ).length;

    const isQuiz = quizQuestions.length > 0;

    return { isQuiz, totalQuestions, answeredQuestions };
  };

  return (
    <>
      {" "}
      <button className="back-button" onClick={() => window.history.back()}>
        ← Back
      </button>
      <Header title="Learner's Course Submissions" />
      <div className="submissions-container">
        <h2 className="title">{course.title}</h2>
        <h3 className="submitted-by">
          {I18n.t("models.learner_submissions.messaging.submitted_by")}:{" "}
          {learner.full_name}
        </h3>
        <div className="lessons-list">
          {lessons.length === 0 ? (
            <div className="no-lessons-message">
              {I18n.t("models.learner_submissions.messaging.no_lessons")}
            </div>
          ) : (
            lessons.map((lesson) => {
              const { isQuiz, totalQuestions, answeredQuestions } =
                getLessonStats(lesson);

              return (
                <div
                  key={lesson.id}
                  className="lesson-card"
                  onClick={() => toggleLesson(lesson.id)}
                >
                  <div className="lesson-header">
                    <span className="lesson-title">
                      {lesson.title}{" "}
                      {isQuiz && <span className="quiz-label">(Quiz)</span>}
                    </span>
                    <span className="expand-icon">
                      {expandedLessonIds.includes(lesson.id) ? "-" : "+"}
                    </span>
                  </div>

                  {expandedLessonIds.includes(lesson.id) && (
                    <div className="lesson-content">
                      {isQuiz && (
                        <p>
                          <strong style={{color: "#333"}}>
                            {I18n.t(
                              "models.learner_submissions.messaging.completed_questions"
                            )}
                            : {answeredQuestions}/{totalQuestions}
                          </strong>{" "}
                        </p>
                      )}

                      {lesson.questions.length > 0 ? (
                        lesson.questions.map((question) => (
                          <div
                            key={question.id}
                            className="question-card"
                          >
                            <div className="question-header">
                              <span className="question-title">
                                {question.text}
                              </span>
                            </div>

                            <div className="question-answer-block">
                              <p className="answer-text">
                                <strong>Answer:</strong>{" "}
                                {question.answer ? (
                                  question.answer
                                ) : question.image_url &&
                                  isImageFile(question.image_url) ? (
                                  <>
                                    <a
                                      href={question.image_url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {getFileNameFromURL(question.image_url)}
                                    </a>
                                    <div
                                      className="answer-image"
                                      style={{ marginTop: "0.5rem" }}
                                    >
                                      <img
                                        src={question.image_url}
                                        alt="Uploaded answer"
                                        style={{
                                          maxWidth: "100%",
                                          maxHeight: "300px",
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    </div>
                                  </>
                                ) : question.image_url ? (
                                  <a
                                    href={question.image_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {getFileNameFromURL(question.image_url)}
                                  </a>
                                ) : (
                                  I18n.t(
                                    "models.learner_submissions.messaging.no_submissions"
                                  )
                                )}
                              </p>

                              {question.hasOwnProperty("attempts") && (
                                <p className="attempts-text">
                                  <strong>
                                    {I18n.t(
                                      "models.learner_submissions.messaging.attempts"
                                    )}
                                    :
                                  </strong>{" "}
                                  {question.attempts}
                                </p>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="no-questions">
                          {I18n.t(
                            "models.learner_submissions.messaging.no_questions"
                          )}{" "}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>{" "}
      </div>
    </>
  );
};

export default LearnerSubmissions;
